import { render, staticRenderFns } from "./UserClaimForm.vue?vue&type=template&id=088e0536"
import script from "./UserClaimForm.vue?vue&type=script&lang=js"
export * from "./UserClaimForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports